<template>
<v-container fluid grid-list-md>
  <!--Dialog para confirmação de exclusão-->
  <p-confirm :text="`Tem certeza que deseja excluir esse item`" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="() => {this.dialogConfirm = false}"></p-confirm>
  <!--Dialog para confirmação de duplicar tarefa-->
  <p-confirm :text="'Tem certeza que deseja duplicar essa tarefa'" :dialog="duplicateDialog" @confirm="confirmDuplicate" @cancel="() => {this.duplicateDialog = false}"></p-confirm>

  <v-layout wrap justify-space-between align-center>
    <v-flex xs12 lg4>
      <span class="headline">Subtarefas</span>
    </v-flex>
    <v-flex xs12 sm6 lg4>
      <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 lg4 class="text-xs-right">
      <v-btn color="primary" @click="() => {openAddSubTask()}" class="mb-4" :loading="loadingBtnAddTask" :disabled="task_shared || loadingBtnAddTask">
        {{this.translate('system.button.add.title')}}
        <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12>
      <p-task-list ref="list" :task_shared="task_shared" :dragDisabled="true"  :allTasks="items" @reloadTasks="getSubtasks()"  :dontShowSubtasks="true" :showMotherTask="false" motherEntity="manageTask" @editSubItem="editSubItem" @doneNewTask="doneNewSubtask" @deleteSubItem="dialogDelete" :idTaskMother="task['id']"  @duplicateTask="openDuplicateDialog" @statusChanged="statusChanged" showCircleInfo
      ></p-task-list>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
  import crud from '../../mixin/crud'
  import rules from '../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PTaskList from './../shared/PTaskList'

  export default {
    mixins: [crud, rules],
    components: { PConfirm, PTaskList },
    name: 'TaskSubtask',
    props: {
      task: Object,
      tab: String,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      items: [],
      allItems: [],
      loadingBtnAddTask: false,
      dialogConfirm: false,
      deletedItem: {},
      search: '',
      du_id: '',
      duplicateDialog: false
    }),
    sockets: {
      addTaskSubTask (task) {
        // como o NotBroadcast está ativo verifica se o item já foi adicionado antes, pois se o usuário estiver na mesma tela ai não pode adicionar duas vezes
        if (!this.items.some((val) => { return val['id'] === task['id'] })) {
          this.items.push(task)
          this.$emit('itemsLength', this.items.length)
        }
      },
      deleteTaskSubTask (id) {
        var index = this.items.findIndex((value) => { return value.id === id })
        // como o NotBroadcast está ativo verifica se o item já foi excluido antes, pois se o usuário estiver na mesma tela ai não precisa excluir duas vezes
        if (index !== -1) this.items.splice(index, 1)
        this.$emit('itemsLength', this.items.length)
      },
      editTaskSubTask (task) {
        var item = this.items.find((value) => { return value.id === task.id })
        // como o NotBroadcast está ativo verifica se o item já foi editado antes, pois se o usuário estiver na mesma tela ai não precisa editar duas vezes
        if (item) Object.assign(item, task)
      },
      // recarrega as subtareafs, geralmente ocorre quando o usuário solicita para recarregar as subtarefas
      reloadTaskSubTask () {
        this.getSubtasks()
      }
    },
    created () {
      this.getSubtasks()
    },
    methods: {
      getSubtasks () {
        this.$http.get(`api/${this.task_shared ? 'get_subtasks_shared' : 'get_subtasks'}/${this.task.id}`).then(res => {
          this.items = res.body
          this.allItems = JSON.parse(JSON.stringify(res.body))
        }, err => {
          if (err.body.message === 'notShared') {
            this.$store.commit('snackbar/change_values', {text: 'Tarefa mãe não está compartilhada!', color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {
              text: `Ocorreu um erro ao listar as subtarefas. Favor reportar o erro.`,
              color: 'error',
              dialog: true
            })
          }
        })
      },
      openAddSubTask () {
        setTimeout(() => {
          // verificação do userId, caso seja uma tarefa de conexão a subtarefa inserida vem sem responsável
          let userId = this.$auth.user().company_id === this.task.company_id ? this.$auth.user().id : null
          this.$refs['list'].openAddTask({identifier: '', user_id: userId, connection_id: null, connection_company_id: null, team_id: this.task.team_id, tasktemplate_id: this.task.tasktemplate_id, company_id: this.task.company_id, category_id: '', client_id: this.task.client_id, task_status_id: '', id_text: '', begin: '', end: '', urgency: '', note: '', task_id: this.task.id, top_id: this.task.top_id, recurrence: {type: '', id_text: {each: '', days: '', months: '', daysToCreate: 1}}, password: '', shared: false, sons: [], identifier_sequence: '', level: this.task.level + 1})
        }, 200)
      },
      editSubItem: function (item, view) {
        this.$emit('editSubItem', item, view)
      },
      doneNewSubtask (val) {
        this.$http.post('api/tasks', val).then((res) => {
          if (res.body.recurrence === null) {
            res.body.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
          }
          this.items.push(res.body)
          // doneNewSubtask adicionar a subtarefa na tela de consulta
          this.$emit('doneNewSubtask', res.body)
          this.$emit('itemsLength', this.items.length)
          // this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.tasks.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
        },
        err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.tasks.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
        })
      },
      dialogDelete (item) {
        this.dialogConfirm = true
        this.deletedItem = item
      },
      deleteItem () {
        // caso seja um item da aba de subtarefas do gerenciamento de tarefas, manda a variavel from_task, pois existem coisas que não devem ser feitas quando deleta do gerenciamento
        this.deletedItem['from_task'] = true
        this.$emit('deleteItem', this.deletedItem)
        this.dialogConfirm = false
      },
      deleteExecuteProcess (id) {
        var index = this.items.findIndex((value) => { return value.id === id })
        this.items.splice(index, 1)
        this.$emit('itemsLength', this.items.length)
      },
      // statusChanged quando altera o status de uma subtarefa dentro do gerenciamento de tarefas, deve atualizar a tela de consulta
      statusChanged (task) {
        this.$emit('statusChanged', task)
      },
      openDuplicateDialog (id) {
        this.du_id = id
        this.duplicateDialog = true
      },
      confirmDuplicate () {
        this.duplicateTaskProcess(this.du_id)
        this.duplicateDialog = false
      },
      duplicateTaskProcess (id) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('api/duplicate_task', id).then(
          (res) => {
            this.$store.commit('loader/change_dialog', false)
            if (res.body.recurrence === null) {
              res.body.recurrence = {type: '', id_text: {each: '', days: '', months: ''}}
            }
            this.items.push(res.body)
            this.$emit('doneNewSubtask', res.body)
            this.$emit('itemsLength', this.items.length)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!',
              color: 'success',
              dialog: true
            })
          }, () => { this.$store.commit('loader/change_dialog', false) }
        )
      }
    },
    watch: {
      search () {
        this.items = this.allItems.filter((val) => {
          const hasValue = val => val != null ? val : ''
          const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          const text = hasValue(val['id_text']).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          // Filtra os registros da pesquisa
          return text.indexOf(search) > -1
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/details/TaskSubtask.vue